import { useMemo } from 'react';
import { useCurrentStore } from './store';

export const useForcedCurrency = (id?: number) => {
    const currentStore = useCurrentStore(id);

    return useMemo(() => {
        if (!currentStore) return null;
        return currentStore.forcedCurrency;
    }, [currentStore]);
};
